import { render, staticRenderFns } from "./RatingBar.vue?vue&type=template&id=c7e87504&scoped=true"
import script from "./RatingBar.vue?vue&type=script&lang=js"
export * from "./RatingBar.vue?vue&type=script&lang=js"
import style0 from "./RatingBar.vue?vue&type=style&index=0&id=c7e87504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e87504",
  null
  
)

export default component.exports